import {
    GET_NAVIGATION_ROUTES_FROM_CMS,
    GET_NAVIGATION_ROUTES_FROM_CMS_ERROR,    
    GET_CMS_PRODUCTOS_AHORRO_CREDITO,
    GET_CMS_PRODUCTOS_AHORRO_CREDITO_ERROR,
    GET_CMS_BARRA_INTERMEDIA,
    GET_CMS_BARRA_INTERMEDIA_ERROR,
    GET_CMS_MAIN_MENU_SECTIONS,
    GET_CMS_MAIN_MENU_SECTIONS_ERROR
} from "./types";
import CMSService from "app/@Base/services/cms.service";

export function getNavigationsRoute(token){
    return function (dispatch){
        try {
            return CMSService.reqNavigationRoutes(token)
                .then((data) => {
                    dispatch({
                        type: GET_NAVIGATION_ROUTES_FROM_CMS,
                        payload:data
                    })
                })
        }
        catch (error) {
            return (dispatch) => {
                dispatch({
                    type:GET_NAVIGATION_ROUTES_FROM_CMS_ERROR
                })
            }
        }

    }
}


export function getProductosAhorroCredito(token) {
    return function (dispatch) {
        try {           
            return CMSService.reqProductosAhorrroCredito(token)
                .then((data) => {
                    dispatch(
                        {
                            type: GET_CMS_PRODUCTOS_AHORRO_CREDITO,
                            payload: data
                        })
                });
        }
        catch (error) {
            return (dispatch) => {
                dispatch({
                    type: GET_CMS_PRODUCTOS_AHORRO_CREDITO_ERROR,
                });
            }
        }
    };
}

export function getBarraIntermedia(token) {
    return function (dispatch) {
        try {           
            return CMSService.reqBarraIntermedia(token)
                .then((data) => {
                    dispatch(
                        {
                            type: GET_CMS_BARRA_INTERMEDIA,
                            payload: data
                        })
                });
        }
        catch (error) {
            return (dispatch) => {
                dispatch({
                    type: GET_CMS_BARRA_INTERMEDIA_ERROR,
                });
            }
        }
    };
}

export function getMainMenuSections(token){
    return function (dispatch){
        try {
            return CMSService.reqMainMenuSections(token)
                .then((data) => {
                    dispatch({
                        type: GET_CMS_MAIN_MENU_SECTIONS,
                        payload:data
                    })
                })
        }
        catch (error) {
            return (dispatch) => {
                dispatch({
                    type:GET_CMS_MAIN_MENU_SECTIONS_ERROR
                })
            }
        }

    }
}